import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface mailingAddressState {
    address: addressType,
}

const initialState: mailingAddressState = {

    address: {
        streetNumber: "",
        unitNumber: "",
        streetName: "",
        city: "",
        province: "",
        postalCode: "",
        country: "",
    },
}

export const mailingAddressSlice = createSlice({
    name: "mailingAddress",
    initialState,
    reducers: {
        setMailStreetNumber: (state, action: PayloadAction<string>) => {
            const streetNumber = action.payload;
            state.address.streetNumber = streetNumber;
        },
        setMailUnitNumber: (state, action: PayloadAction<string>) => {
            const unitNumber = action.payload;
            state.address.unitNumber = unitNumber;
        },
        setMailStreetName: (state, action: PayloadAction<string>) => {
            const streetName = action.payload;
            state.address.streetName = streetName;
        },
        setMailCity: (state, action: PayloadAction<string>) => {
            const city = action.payload;
            state.address.city = city;
        },
        setMailProvince: (state, action: PayloadAction<string>) => {
            const province = action.payload;
            state.address.province = province;
        },
        setMailPostalCode: (state, action: PayloadAction<string>) => {
            const postalCode = action.payload;
            state.address.postalCode = postalCode;
        },
        setMailCountry: (state, action: PayloadAction<string>) => {
            const country = action.payload;
            state.address.country = country;
        },


        clearMailingAddressState: (state) => {
            state.address.streetNumber = "";
            state.address.streetName = "";
            state.address.unitNumber = "";
            state.address.city = "";
            state.address.province = "";
            state.address.postalCode = "";
            state.address.country = "";
        }
    }
});

export const { setMailStreetNumber, setMailUnitNumber, setMailStreetName, setMailCity, setMailProvince, setMailPostalCode, setMailCountry, clearMailingAddressState } = mailingAddressSlice.actions

export default mailingAddressSlice.reducer

export const selectMailingAddress = (state: RootState) => state.mailingAddress;

